/**
 * Contest File Upload
 *
 * Obsługuje kontrolkę uploadu plików w formularzu konkursowym:
 * - kliknięcie otwiera dialog wyboru pliku
 * - drag & drop
 * - walidacja formatu i rozmiaru (200 MB)
 * - lista wybranych plików z podglądem miniatur (obrazki) / ikoną (pliki)
 * - usuwanie plików z listy
 *
 * Sam upload na serwer będzie obsłużony przez inny zespół —
 * ten moduł zarządza tylko stanem UI i trzyma pliki w DataTransfer.
 */

(function () {
  'use strict';

  var MAX_SIZE = 200 * 1024 * 1024; // 200 MB
  var ALLOWED_EXT = ['mp4', 'flv', 'mkv', 'mov', 'avi', 'jpg', 'jpeg', 'png', 'pdf'];

  var container = document.querySelector('[data-file-upload]');
  if (!container) return;

  var area = container.querySelector('[data-file-upload-area]');
  var input = container.querySelector('[data-file-upload-input]');
  var list = container.querySelector('[data-file-upload-list]');

  if (!area || !input || !list) return;

  // Store selected files (array, since FileList is immutable)
  var selectedFiles = [];

  // ---- Helpers ----

  function getExtension(filename) {
    var parts = filename.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
  }

  function formatSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function isImage(file) {
    return /^image\/(jpeg|png)$/i.test(file.type);
  }

  function validateFile(file) {
    var ext = getExtension(file.name);
    if (ALLOWED_EXT.indexOf(ext) === -1) {
      return 'Nieobsługiwany format pliku.';
    }
    if (file.size > MAX_SIZE) {
      return 'Plik przekracza 200 MB.';
    }
    return null;
  }

  // ---- Sync files to native input (for form submission) ----

  function syncInputFiles() {
    try {
      var dt = new DataTransfer();
      selectedFiles.forEach(function (f) {
        dt.items.add(f);
      });
      input.files = dt.files;
    } catch (e) {
      // DataTransfer not supported in older browsers — files stay in selectedFiles array
    }
  }

  // ---- Render ----

  function renderFileList() {
    list.innerHTML = '';

    selectedFiles.forEach(function (file, index) {
      var error = validateFile(file);
      var item = document.createElement('div');
      item.className = 'contest-form__file-item';

      // Thumbnail or icon
      if (isImage(file) && !error) {
        var thumb = document.createElement('img');
        thumb.className = 'contest-form__file-thumb';
        thumb.alt = file.name;
        thumb.src = URL.createObjectURL(file);
        item.appendChild(thumb);
      } else {
        var icon = document.createElement('span');
        icon.className = 'contest-form__file-icon';
        icon.textContent = getExtension(file.name) || '?';
        item.appendChild(icon);
      }

      // File info
      var info = document.createElement('div');
      info.className = 'contest-form__file-info';

      var nameEl = document.createElement('p');
      nameEl.className = 'contest-form__file-name';
      nameEl.textContent = file.name;
      info.appendChild(nameEl);

      if (error) {
        var errorEl = document.createElement('p');
        errorEl.className = 'contest-form__file-error';
        errorEl.textContent = error;
        info.appendChild(errorEl);
      } else {
        var sizeEl = document.createElement('p');
        sizeEl.className = 'contest-form__file-size';
        sizeEl.textContent = formatSize(file.size);
        info.appendChild(sizeEl);
      }

      item.appendChild(info);

      // Remove button
      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'contest-form__file-remove';
      removeBtn.setAttribute('aria-label', 'Usuń plik ' + file.name);
      removeBtn.innerHTML = '&times;';
      removeBtn.addEventListener('click', function () {
        removeFile(index);
      });
      item.appendChild(removeBtn);

      list.appendChild(item);
    });

    // Toggle error class on the area
    var hasErrors = selectedFiles.some(function (f) {
      return validateFile(f) !== null;
    });
    area.classList.toggle('is-error', hasErrors);
  }

  // ---- Add / Remove ----

  function addFiles(fileListObj) {
    for (var i = 0; i < fileListObj.length; i++) {
      // Prevent duplicates (same name + size)
      var file = fileListObj[i];
      var isDuplicate = selectedFiles.some(function (f) {
        return f.name === file.name && f.size === file.size;
      });
      if (!isDuplicate) {
        selectedFiles.push(file);
      }
    }
    syncInputFiles();
    renderFileList();
  }

  function removeFile(index) {
    selectedFiles.splice(index, 1);
    syncInputFiles();
    renderFileList();
  }

  // ---- Event handlers ----

  // Click on area → trigger file input
  area.addEventListener('click', function (e) {
    // Don't trigger if clicking on file list items inside area
    if (e.target.closest('[data-file-upload-list]')) return;
    input.click();
  });

  // File input change
  input.addEventListener('change', function () {
    if (input.files && input.files.length) {
      addFiles(input.files);
    }
  });

  // Drag & drop
  area.addEventListener('dragenter', function (e) {
    e.preventDefault();
    e.stopPropagation();
    area.classList.add('is-dragover');
  });

  area.addEventListener('dragover', function (e) {
    e.preventDefault();
    e.stopPropagation();
    area.classList.add('is-dragover');
  });

  area.addEventListener('dragleave', function (e) {
    e.preventDefault();
    e.stopPropagation();
    // Only remove if leaving the area entirely
    if (!area.contains(e.relatedTarget)) {
      area.classList.remove('is-dragover');
    }
  });

  area.addEventListener('drop', function (e) {
    e.preventDefault();
    e.stopPropagation();
    area.classList.remove('is-dragover');

    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
      addFiles(e.dataTransfer.files);
    }
  });

  // Keyboard a11y — Enter/Space on area
  area.setAttribute('tabindex', '0');
  area.setAttribute('role', 'button');
  area.setAttribute('aria-label', 'Kliknij lub przeciągnij pliki, aby je dodać');

  area.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      input.click();
    }
  });
})();
